import { Button } from "@design-system/Button/Button";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { HStack } from "@design-system/HStack/HStack";
import { Loader } from "@design-system/Loader/Loader";
import { Pagination } from "@design-system/Pagination/Pagination";
import { Shortcut } from "@design-system/Shortcut/Shortcut";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    ScheduleSelectionMonth,
    ScheduleSelectionTotals,
} from "./scheduleApplicationSelectionTotals";
import { ScheduleApplicationsTotals } from "./ScheduleApplicationsTotals";

interface ScheduleApplicationsFooterProps {
    total: number;
    currentPage: number;
    pageCount: number;
    onPageChange: (page: number) => void;
    isFetching: boolean;
    selectedCount: number;
    totals: ScheduleSelectionTotals;
    months: ScheduleSelectionMonth[];
    remainingAsOfLabel: string | null;
    onClearSelection: () => void;
    onOpenBulkActions: () => void;
}

export const ScheduleApplicationsFooter = ({
    total,
    currentPage,
    pageCount,
    onPageChange,
    isFetching,
    selectedCount,
    totals,
    months,
    remainingAsOfLabel,
    onClearSelection,
    onOpenBulkActions,
}: ScheduleApplicationsFooterProps) => {
    if (total === 0) {
        return null;
    }
    const hasSelection = selectedCount > 0;
    return (
        <CommandIsland
            sticky
            className={commandIslandStyles.bulkActionsStickyFooter}
        >
            <HStack gap={8}>
                {isFetching ? (
                    <Loader inline delayed />
                ) : (
                    pageCount > 1 && (
                        <Pagination
                            size="md"
                            pageCount={pageCount}
                            currentPage={currentPage}
                            onPageChange={onPageChange}
                            buttonsPosition="left"
                        />
                    )
                )}
                <ScheduleApplicationsTotals
                    totals={totals}
                    months={months}
                    remainingAsOfLabel={remainingAsOfLabel}
                />
                {hasSelection && (
                    <Tooltip
                        key={selectedCount}
                        content={`Deselect ${selectedCount}`}
                    >
                        <Button
                            variant="primary"
                            size="md"
                            onClick={onClearSelection}
                        >
                            {selectedCount} selected
                        </Button>
                    </Tooltip>
                )}
            </HStack>
            {hasSelection && (
                <Tooltip content="Open bulk actions">
                    <Button
                        variant="primary"
                        size="md"
                        onClick={onOpenBulkActions}
                        rightIcon={
                            <span data-slot-box="">
                                <Shortcut keys="mod+k" />
                            </span>
                        }
                    >
                        Actions
                    </Button>
                </Tooltip>
            )}
        </CommandIsland>
    );
};
